<ng-container *ngIf="content$ | async as banner">
  <shrd-uic-modal
    #marketingModal
    [fitToContent]="true"
    size="sm"
    [customContentRef]="bannerContent"
    windowClass="marketing-banner-modal"
    [autoOpen]="opened"
    (dismiss)="onModalClose($event, banner)"
  >
    <ng-template #bannerContent>
      <shrd-uic-marketing-banner
        #marketingBanner
        [headline]="banner.headline"
        [subHeadline]="banner.subHeadline | stripHtml"
        [layoutType]="banner.layout"
        [imageUrl]="banner.imageUri"
        [imageAlt]="banner.imageAlt"
        [buttons]="banner.links"
        [dontShowAgainButtonLabel]="'common.label.dontShowAgain' | i18next"
        (closeButtonClick)="marketingModal.close(); temporarilyBanBanner(banner)"
        (dontShowAgainButtonClick)="marketingModal.close(); permanentlyBanBanner(banner)"
        (ctaButtonClick)="
          marketingModal.close(); handleCtaClick($event, banner); marketingBanner.ctaButtonClick.complete()
        "
      ></shrd-uic-marketing-banner>
    </ng-template>
  </shrd-uic-modal>
</ng-container>
